import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  render() {
    return (

      <div>

        <footer className="page-footer">
          <div className="container">
            <div className="row">
              <div className="col l6 s12">
                <h6 className="white-text">Policies & Legal</h6>
                  <ul>
                    <li><Link className="grey-text text-lighten-3" to="/privacy-center">Privacy Center</Link></li>
                    <li><Link className="grey-text text-lighten-3" to="/privacy-policy">Privacy Policy</Link></li>
                    <li><Link className="grey-text text-lighten-3" to="/copyright-policy">Copyright Policy</Link></li>
                    <li><Link className="grey-text text-lighten-3" to="/terms-use">Terms Of Use</Link></li>
                  </ul>
              </div>

              <div className="col l4 offset-l2 s12">
                <h6 className="white-text">Useful Links</h6>
                <ul>
                  <li><Link className="grey-text text-lighten-3" to="/">Home</Link></li>
                  <li><Link className="grey-text text-lighten-3" to="/about-us">About Us</Link></li>
                  <li><Link className="grey-text text-lighten-3" to="/join-team">Join Our Team</Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="container App">
              <br/>
              © 2016-2018 RKM INC.   All Rights Reserved.

            </div>
          </div>
        </footer>

      </div>

    );
  }
}

export default Footer;


/*
<a
          className="grey-text text-lighten-4 right App-link"
          href="https://kalibbala.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit My Site here
</a>
*/
